import { fromAuthorisationResponses, toAuthorisationRequests } from '../models/mapper'
import { AuthorisationUpdate } from '../models/request'
import { Authorisation } from '../models/types'
import { updateAuthorisationsV2 } from './http'

// eslint-disable-next-line import/prefer-default-export
export async function updateAuthorisations(updates: AuthorisationUpdate[]): Promise<Authorisation[]> {
  const responses = await updateAuthorisationsV2(toAuthorisationRequests(updates))
  return fromAuthorisationResponses(responses)
}
